import { render, staticRenderFns } from "./OwnerPreview.vue?vue&type=template&id=5822ebc4&scoped=true"
import script from "./OwnerPreview.vue?vue&type=script&lang=js"
export * from "./OwnerPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822ebc4",
  null
  
)

export default component.exports